<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    value-key="code"
                    placeholder="请选择纤维"/>
</template>

<script>
/**
 * @Description: 纤维自动搜索组件
 * @Author: 菩萨蛮
 * @Date: 2021/3/30 11:52 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import AutoComplete from '../../../mixins/common/AutoComplete';

export default {
  name: 'FibreAutoComplete',
  mixins: [AutoComplete],
  data() {
    return {
      url: '/base/info/fibre?pageSize=5&pageNum=0&code=',
      itemName: 'code'
    };
  }
};
</script>

<style lang="scss" scoped>

</style>
